import Choices from 'choices.js';
import Map from './map.js'

export default class Appointment {
    constructor() {
        if (null !== document.getElementById('pageAppointment')) {
            this.init();
        }
    }

    init() {
        this.map = new Map('map');

        const dateSelect = document.getElementById('selectDate');
        this.dateSelectChoices = new Choices(dateSelect, {shouldSort: false});

        const timeSelect = document.getElementById('selectTime');
        this.timeSelectChoices = new Choices(timeSelect);

        this.appointmentButton = document.getElementById('appointmentButton');

        this.reset();
        this.initPostalCodeSearch();
        this.initDateSelect();
        this.initTimeSelect();
        this.initLoadAllLocationsButton();
    }

    reset() {
        this.resetDateSelect()
            .resetTimeSelect();

        return this;
    }

    resetDateSelect() {
        this.dateSelectChoices.setChoices(
            [{
                value: '',
                label: 'Selecteer eerst een locatie'
            }],
            'value',
            'label',
            true
        ).setChoiceByValue('')
            .disable();

        this.appointmentButton.disabled = true;

        return this;
    }

    resetTimeSelect() {
        this.timeSelectChoices.setChoices(
            [{
                value: '',
                label: 'Selecteer eerst een datum'
            }],
            'value',
            'label',
            true
        ).setChoiceByValue('')
            .disable();

        this.appointmentButton.disabled = true;

        return this;
    }

    initPostalCodeSearch() {
        const postalCodeInput = document.getElementById('postalCode');
        const searchByPostalCodeForm = document.getElementById('searchByPostalCodeForm');

        searchByPostalCodeForm.addEventListener('submit', event => {
            event.preventDefault();

            const url = searchByPostalCodeForm.getAttribute('action')
            const data = new FormData(searchByPostalCodeForm);
            axios.post(url, data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
            }).then(response => {
                postalCodeInput.closest('.row').classList.remove('has-errors');
                this.updateLocations(response.data);

                const LoadAllButton = document.getElementById('LoadAllButton');
                LoadAllButton.classList.remove('d-none');
            }).catch(response => {
                postalCodeInput.closest('.row').classList.add('has-errors');
            });
        });

        if(postalCodeInput.value) {
            searchByPostalCodeForm.dispatchEvent(new Event('submit'));
        }
    }

    initLoadAllLocationsButton() {
        const LoadAllButton = document.getElementById('LoadAllButton');

        LoadAllButton.addEventListener('click', event => {
            const url = searchByPostalCodeForm.getAttribute('action') + '?all=true'
            const data = new FormData(searchByPostalCodeForm);

            axios.post(url, data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
            }).then(response => {
                this.updateLocations(response.data);

                LoadAllButton.classList.add('d-none');
            }).catch(response => {
                //
            });
        });
    }

    initDateSelect() {
        this.dateSelectChoices.passedElement.element.addEventListener('change', event => {
            this.loadTimes();
        });
    }

    initTimeSelect() {
        this.timeSelectChoices.passedElement.element.addEventListener('change', event => {
            this.appointmentButton.disabled = event.detail.value === '';
        });
    }

    updateLocations(locations) {
        const locationContainer = document.getElementById('locations');

        const template = document.getElementById('locationTemplate').innerHTML;

        const positions = [];

        let html = '';
        locations.forEach(location => {
            const address = location.straat + ', ' + location.postcode + ' ' + location.plaats;

            html += template.replace('{{ location }}', location.locatieId + '-' + location.vestigingId)
                .replace('{{ name }}', location.omschrijving)
                .replace('{{ address }}', address)
                .replace('{{ noAppointment }}', !location.magDirectAfsprakMakenJN)
                .replace('{{ noAppointmentMessage }}', (location.geenAfspraaktekst + '').replaceAll('\\n\\n', ' ').replaceAll('\\n', ' '))
                .replace('{{ distance }}', location.distance + ' km');

            if (location.distance < 300) {
                positions.push(location.coordinates);
            }
        })

        locationContainer.innerHTML = html;

        this.map.clearMarkers();
        this.map.addMarkers(positions);

        document.querySelectorAll('.location button')
            .forEach(button => {
                button.addEventListener('click', event => {
                    document.querySelectorAll('.location').forEach(element => {
                        element.classList.remove('selected');
                    })

                    const location = event.target.closest('.location');
                    location.classList.add('selected');

                    const noAppointmentMessageContainer = document.getElementById('noAppointmentMessageContainer');
                    const appointmentFormContainer = document.getElementById('appointmentFormContainer');
                    const noAppointment = location.getAttribute('data-no-appointment') === 'true';
                    if (noAppointment) {
                        appointmentFormContainer.classList.add('d-none');
                        noAppointmentMessageContainer.innerText = location.getAttribute('data-no-appointment-message');
                        noAppointmentMessageContainer.classList.remove('d-none');
                    } else {
                        noAppointmentMessageContainer.classList.add('d-none');
                        appointmentFormContainer.classList.remove('d-none');
                    }

                    // init form
                    document.getElementById('locatieInput').value = location.getAttribute('data-locatie')
                    this.loadDates();
                });
            });
    }

    loadDates() {
        const selectedLocation = document.getElementById('locatieInput');
        const url = '/locaties/' + selectedLocation.value;

        if (selectedLocation.value === '') {
            this.reset();

            return;
        }

        axios.get(url).then(response => {
            this.reset();

            const choices = [];
            if (response.data.length > 0) {
                choices.push({
                    value: '',
                    label: 'Selecteer een datum'
                });
                response.data.forEach(date => {
                    choices.push(date);
                });
                this.dateSelectChoices.enable();
            } else {
                choices.push({
                    value: '',
                    label: 'Selecteer een andere locatie'
                });
            }

            this.dateSelectChoices.setChoices(
                choices,
                'value',
                'label',
                true
            ).setChoiceByValue(choices[0].value);
        });
    }

    loadTimes() {
        const selectedLocation = document.getElementById('locatieInput');
        const selectedDate = this.dateSelectChoices.getValue();
        const url = '/locaties/' + selectedLocation.value + '/' + selectedDate.value;

        if (selectedDate.value === '') {
            this.resetTimeSelect();

            return;
        }

        axios.get(url).then(response => {
            this.resetTimeSelect();

            const choices = [];
            if (response.data.length > 0) {
                choices.push({
                    value: '',
                    label: 'Selecteer een tijd'
                });
                response.data.forEach(time => {
                    choices.push(time);
                });
                this.timeSelectChoices.enable();
            } else {
                choices.push({
                    value: '',
                    label: 'Selecteer een andere datum'
                });
            }

            this.timeSelectChoices.setChoices(
                choices,
                'value',
                'label',
                true
            ).setChoiceByValue(choices[0].value);
        });
    }
}

